import { useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import AboutSection from '../components/AboutSection';
import ContactSection from '../components/ContactSection';
import DonationAccountsSection from '../components/DonationAccountsSection';
import ContributionFormSection from '../components/ContributionFormSection';
import { useContributionOptions } from '../hooks/useContributionOptions';
import SomalilandResourcesSection from '../components/SomalilandResourcesSection';
import SectorsSection from '../components/SectorsSection';
import PublicTotalsSection from '../components/PublicTotalsSection';
import { useLanguage } from '../LanguageContext';
import HeroVisual from '../components/HeroVisual';

export default function HomePage() {
  const { t } = useLanguage();
  const location = useLocation();
  const {
    donationProjects,
    investmentProjects,
    paymentMethods,
    loading: optionsLoading,
    error: optionsError,
    reload: reloadOptions,
  } = useContributionOptions();

  useEffect(() => {
    if (!location.hash) return;
    const id = location.hash.replace(/^#/, '');
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }, [location.hash, location.pathname]);

  return (
    <>
      <header className="hero">
        <div className="hero__backdrop" aria-hidden="true" />
        <div className="hero__inner">
          <div className="hero__layout">
            <div className="hero__content">
              <p className="hero__eyebrow">{t('hero.eyebrow')}</p>
              <h1 className="hero__title">{t('hero.title')}</h1>
              <p className="hero__lead">{t('hero.lead')}</p>
              <div className="hero__actions">
                <Link className="hero__cta" to="/#donate">
                  <span className="hero__cta-text">{t('hero.cta')}</span>
                  <span className="hero__cta-icon" aria-hidden="true">
                    <svg
                      width="18"
                      height="18"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M5 12h14m-3-4 4 4-4 4"
                        stroke="currentColor"
                        strokeWidth="2.25"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </span>
                </Link>
              </div>
            </div>
            <HeroVisual />
          </div>
        </div>
        <div className="hero__wave" aria-hidden="true">
          <svg
            className="hero__wave-svg"
            viewBox="0 0 1440 56"
            preserveAspectRatio="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              className="hero__wave-path"
              d="M0 28 C 240 8 480 44 720 28 C 960 12 1200 40 1440 24 L 1440 56 L 0 56 Z"
            />
          </svg>
        </div>
      </header>

      <main>
        <AboutSection />

        <SectorsSection />

        <SomalilandResourcesSection />

        <PublicTotalsSection />

        <DonationAccountsSection methods={paymentMethods} loading={optionsLoading} />

        <ContributionFormSection
          donationProjects={donationProjects}
          investmentProjects={investmentProjects}
          paymentMethods={paymentMethods}
          optionsLoading={optionsLoading}
          optionsError={optionsError}
          onRetryOptions={reloadOptions}
        />

        <ContactSection />
      </main>
    </>
  );
}
